// Keep the identity function around for default iteratees.
export default function identity(value) {
  return value;
}



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/identity.js
// module id = 181
// module chunks = 8